import React from 'react';
import { FormOption } from '../types/api';
import { formatTimeString } from '../utils/dateUtils';
import QuestionHeader from './shared/QuestionHeader';
import QuestionOptions from './shared/QuestionOptions';
import MomentExpression from './MomentExpression';
import '../styles/components/QuestionCard.css';

interface Evidence {
  id: number;
  analysis_config_id: number;
  start_time: string;
  end_time: string;
  evidence: string;
}

interface PreviewQuestionCardProps {
  id: string | number;
  questionNumber: number;
  questionText: string;
  questionType: string;
  optionType: string;
  options?: FormOption[];
  points: number;
  evaluationId: string;
  evidences?: Evidence[];
  onEvidenceClick?: (startTime: string) => void;
  prompt: string;
  moments?: {
    id: number;
    name: string;
    operation: string;
  }[];
}

const PreviewQuestionCard: React.FC<PreviewQuestionCardProps> = ({
  id,
  questionNumber,
  questionText,
  questionType,
  optionType,
  options = [],
  points,
  evaluationId,
  evidences,
  onEvidenceClick,
  prompt,
  moments = []
}) => {
  const getScoreText = () => {
    return `${points || 0}`;
  };

  const getScoreColor = () => {
    return 'preview-score';
  };

  return (
    <div className="question-card">
      <div className="question-main-card">
        <QuestionHeader
          questionNumber={questionNumber}
          questionText={questionText}
          scoreText={getScoreText()}
          scoreColorClass={getScoreColor()}
        />
        
        <div className="card-content">
          {/* Show prompt or moment expression above options */}
          {questionType === 'Moment' && moments && moments.length > 0 && (
            <div className="preview-prompt-moment">
              <MomentExpression 
                moments={moments}
                isPreview={true}
                onMomentClick={undefined}
              />
            </div>
          )}
          {questionType === 'Prompt' && prompt && (
            <div className="preview-prompt-moment">
              <span className="preview-prompt-text">{prompt}</span>
            </div>
          )}
          
          <QuestionOptions
            optionType={optionType}
            options={options}
            questionId={id}
            moments={moments}
          />
                    
          {evidences && evidences.length > 0 && (
            <div className="evidence-section">
              <div className="evidence-list">
                {evidences.map((evidence, index) => (
                  <div 
                    key={index} 
                    className="evidence-item"
                    onClick={() => onEvidenceClick?.(evidence.start_time)}
                    role="button"
                    title="Click to play this segment"
                  >
                    <span className="material-symbols-outlined evidence-play-icon">sound_sampler</span>
                    <span className="evidence-time">{"[" + formatTimeString(evidence.start_time) + "]"}</span>
                    <span className="evidence-text">{evidence.evidence}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PreviewQuestionCard;

